import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Stack)`
  font-size: 14px;
  flex-shrink: 0;
`;
